import React from 'react';
import { useTranslation } from 'react-i18next';

const MetricsCards = ({ metrics }) => {
  const { t } = useTranslation();
  const cards = [
    {
      title: t('admin.reports.metrics.total_bookings'),
      value: metrics.totalBookings,
      icon: '/icons/all.png',
      color: 'blue'
    },
    {
      title: t('admin.reports.metrics.completed_bookings'),
      value: metrics.totalCompleted,
      icon: '/icons/checked.png',
      color: 'green'
    },
    {
      title: t('admin.reports.metrics.pending_bookings'),
      value: metrics.totalPending,
      icon: '/icons/pending.png',
      color: 'orange'
    },
    {
      title: t('admin.reports.metrics.cancelled_bookings'),
      value: metrics.totalCancelled,
      icon: '/icons/cancel.png',
      color: 'red'
    },
    {
      title: t('admin.reports.metrics.total_guests'),
      value: metrics.totalGuest,
      icon: '/icons/persons.png',
      color: 'purple'
    }
  ];

  return (
    <div className="metrics-cards">
      {cards.map((card, index) => (
        <div key={index} className={`metric-card ${card.color}`}>
          <div className="metric-icon">
            <img src={card.icon} alt={card.title} className="card-icon"/>
          </div>
          <div className="metric-content">
            <h3 className="metric-title">{card.title}</h3>
            <p className="metric-value">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsCards;